
<div class="table-responsive list-wrapper-bordered">
    <table class="table table-striped table-hover table-borderless border-0">
        <thead>
        <tr>
            <th class="text-nowrap">Date</th>
            <th class="text-nowrap">Competition Level</th>
            <th class="sticky-action"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let s of scorecards">
            <td class="text-nowrap" style="color: #000;">{{ s.assessmentDate | date : "MM/dd/y" }}</td>
            <td class="text-nowrap" style="color: #000;">{{ s.competitionLevel }}</td>
            <td class="sticky-action">
                <button (click)="seeDetail(s)" style="background: #5B25B4; color:#fff" mat-raised-button aria-label="edit scorecard">
                    See Detail
                </button>
            </td>
        </tr>
        <tr *ngIf="scorecards.length == 0">
            <td colspan="7" class="text-center">
                <span>No assessment available </span>
            </td>
        </tr>
        </tbody>
    </table>
</div>
<div class="mt-4" *ngIf="scorecards.length > 0">
    <app-pagination
            (goPage)="toPage($event)"
            (goPerPage)="perPageSet($event)"
            [pagesToShow]="showPages"
            [page]="pageNo"
            [perPage]="pageSize"
            [count]="totalRow"></app-pagination>
</div>
